interface User {
  account_id: string;
  avatar: string;
  display_name: string;
  is_staff: true;
  is_team: false;
  nickname: string;
  uuid: string;
}

declare global {
  namespace BB {
    type V1User = User;
  }
}

export type V1User = User;
